<template>
  <div class="swiper-main-box">
    <div class="news-swiper-container" :class="{'mobile-swiper-container':isMobile}">
      <div class="nullSwiper" v-if="bannerImg.length == 0">
        <a-spin/>
      </div>
      <swiper :options="swiperOption" ref="mySwiper" v-if="bannerImg.length!=0">
        <!-- slides -->
        <swiper-slide v-for="(item,key) in bannerImg" :key="key">
          <div style="border-radius: 8px;overflow: hidden" v-if="IsShowMobile" @click="openPage(item)"
               class="topImg-mobile">
            <img :src="item.imgUrl" alt="" style="border-radius: 8px">
          </div>

          <div v-else @click="openPage(item)"
               class="topImg"
               :style="{backgroundImage: 'url(' + item.imgUrlPc + ')',borderRadius:'16px'}">
          </div>

        </swiper-slide>
        <!--分页器-->
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev" v-if="!isMobile"><img src="@assets/img/index/swiper-left-button.png" alt=""></div>
        <div class="swiper-button-next" slot="button-next" v-if="!isMobile"><img src="@assets/img/index/swiper-right-button.png" alt=""></div>
        <!--<div class="swiper-scrollbar" slot="scrollbar"></div>-->
      </swiper>
    </div>
  </div>
</template>

<script>
import {bannerList} from "@api/course-api"
import common from "../../mixin/common";

export default {
  name: "Carousel",
  mixins: [common],
  data() {
    return {
      //是否展示手机轮播图
      IsShowMobile: false,
      bannerImg: [],
      //swiper轮播图
      swiperOption: { //更多的参数的配置看swiper4官网介绍：http://www.swiper.com.cn/api/navigation/210.html
        notNextTick: true,
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,//修改swiper的父元素时，自动初始化swiper
        loop: {
          loop: true
        },
        speed: 1200,
        autoplay: {
          delay: 1000,
          disableOnInteraction: false,
        },
        direction: 'horizontal',
        grabCursor: true,
        setWrapperSize: true,
        centeredSlides:true,
        autoHeight: true,
        // pagination : '.swiper-pagination',
        // paginationClickable :true,
        navigation: { //最新版本的需要这样配置，按钮才有效
          prevEl: '.swiper-button-prev',//上一张
          nextEl: '.swiper-button-next'//下一张
        },
        scrollbar: '.swiper-scrollbar',//滚动条
        mousewheelControl: true,
        clickable: true,

        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          // type: "bullets"
        },
      },
    }
  },
  created() {
    if (this.isMobile) {
      this.IsShowMobile = true
    }
    bannerList().then((res) => {
      this.bannerImg = res.data
    })
  },
  methods: {
    openPage(carouselInfo) {
      let href;
      switch (carouselInfo.type) {
        case 'article':
          href = this.$router.resolve({
            name: "articleDetail",
            params: {
              id: carouselInfo.id
            }
          });
          break;
        case 'course':
          href = this.$router.resolve({
            name: "courseDetail",
            params: {
              courseId: carouselInfo.id
            }
          });

          break;
      }
      window.open(href.href, '_blank');

    }
  }
}
</script>

<style scoped lang="less">
.swiper-button-prev{
  left: 0;
}
.swiper-button-next{
  right: 0;
}
/deep/.swiper-button-next{background-image:none;}
/deep/.swiper-button-prev{background-image:none;}
/deep/ .swiper-container-autoheight{
  border-radius: 8px;
  overflow: hidden;
}

.news-swiper-container {
  min-width: 100%;
  background: #fff;
  border-radius: 8px;
  padding: 16px;
}

.topImg {
  /*background: url("../../assets/img/关于我们.jpg") no-repeat center;*/
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  border-radius: 8px;
  height: 400px;
  background-size: cover;
}

.topImg-mobile {
  width: 100%;
  /*height: 170px;*/
  /*min-height: 170px;*/
  background-size: 100%;

  img {
    width: 100%;
    display: block;
  }
}

/deep/ .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
}

.nullSwiper {
  padding: 50px;
  text-align: center;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}

@media (max-width: 576px) {
  /*//<=768的设备   手机，paid */
  .nullSwiper {
    padding: 75px;
  }

  .topImg-mobile {
    /*min-height: 145px;*/
    /*width: 414px;*/
  }

}

@media (min-width: 768px) {
  /*//>=768的设备   ipadpro */
  .nullSwiper {
    padding: 200px;
  }

  .topImg-mobile {
    /*min-height: 340px;*/
  }
}

@media (min-width: 992px) {
  /*//>=992的设备   小屏电脑*/
  .nullSwiper {
    padding: 200px;
  }

  .topImg-mobile {
    /*min-height: 460px;*/
  }

}

@media (min-width: 1200px) {
  /*//>=1200的设备   电脑*/
  .nullSwiper {
    padding: 188px;
  }

  .topImg-mobile {
    min-height: 460px;
  }

}

@media (min-width: 1600px) {
  /*//>=1200的设备  大屏电脑*/
  .nullSwiper {
    padding: 188px;
  }

  .topImg-mobile {
    min-height: 460px;
  }
}

// 专门为移动端写的样式
.mobile-swiper-container {
  width: 100%;
  min-width: 100%;
  padding: 8px;

}


</style>
